/**
 * Initialize everything related to item's refunds view
 */

class RefundsView {
  constructor(options = {}) {
    const defaults = {
      enabledPages: '.refunds',
      buttonsCancelSelector: '.cell--cancel .button',
      inputAmountSelector: '#create-refund__amount',
      inputDescriptionSelector: '#create-refund__description',
      buttonSubmitSelector: '.refunds__form button[type="submit"]',
      inputRefundSelector: 'input[type="hidden"][name="refund"]'
    }

    Object.assign(this, defaults, options);
  }

  /**
   * Select elements and bind events, if applicable.
   */
  init() {
    // Exit early, if not on enabled page
    if(!document.querySelector(this.enabledPages)) return;

    this._buttonsCancel = document.querySelectorAll(this.buttonsCancelSelector);
    this._inputAmount = document.querySelector(this.inputAmountSelector);
    this._inputDescription = document.querySelector(this.inputDescriptionSelector);
    this._inputRefund = document.querySelector(this.inputRefundSelector);
    this._buttonSubmit = document.querySelector(this.buttonSubmitSelector);

    this._buttonsCancel.forEach((button) =>
      button.addEventListener(
        'click',
        (event) => this.handleCancelButton(button)
      )
    );
  }

  /**
   * Event handler for cancelling a refund by copying the selected
   * refund's price into a new, negative refund.
   * TODO: Might want to consider moving this logic behind a new API endpoint?
   *
   * @param {HTMLButtonElement} button - A button with data-for-amount and data-for-refund attributes
   */
  handleCancelButton(button) {
    const confirmMessage = button.dataset.confirm || 'Are you sure?';
    // A confirm will do for now, consider custom modals later
    if(!window.confirm(confirmMessage)) return; // eslint-disable-line no-alert

    const amount = button.dataset.forAmount;
    this._inputAmount.value = 0 - amount;

    const refundPid = button.dataset.forRefund;
    this._inputRefund.value = refundPid;

    const description = button.dataset.cancelDescription || `Peruttu hyvitys (#${ refundPid })`;
    this._inputDescription.value = description;

    this._buttonSubmit.click();
  }
}

module.exports = RefundsView;
